import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { Marker } from "../../../common/Marker";
import { CenteredWrapper } from "../../../RankingWidget/WidgetChart/styles";

import { TooltipValue } from "./styles";

type ChartTooltipContentSchema = {
    primaryName: string;
    percentageValue: string;
};

const ChartTooltipContent = ({ primaryName, percentageValue }: ChartTooltipContentSchema) => (
    <Flex
        alignItems="center"
        justifyContent="space-between"
    >
        <CenteredWrapper>
            <Marker backgroundColor={colorsPalettes.blue[500]} />
            <TooltipValue>
                {primaryName} ({translate("common.you")})
            </TooltipValue>
        </CenteredWrapper>
        <TooltipValue>{percentageValue}</TooltipValue>
    </Flex>
);

export default ChartTooltipContent;
